import { useMemo } from 'react';

import { Locale } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import ru from 'date-fns/locale/ru';

const localeMap: Record<string, Locale> = {
    en: enUS as unknown as Locale,
    'en-us': enUS as unknown as Locale,
    ru: ru as unknown as Locale,
    'ru-ru': ru as unknown as Locale,
};

/**
 * React-хук для определения локали date-fns на основе глобальной переменной LOCALE,
 * языка браузера пользователя (navigator.language) или дефолтной локали 'en-US'.
 *
 * Локаль определяется по приоритету:
 *   1. LOCALE (из переменных окружения)
 *   2. navigator.language (язык браузера)
 *   3. 'en-US' (по умолчанию)
 *
 * Поддерживает различные форматы записи локали, например: 'en', 'en-US', 'ru', 'ru-RU'.
 * Для расширения поддерживаемых языков просто добавьте новые локали в localeMap.
 *
 * @example
 * const locale = useDateFnsLocale();
 * format(new Date(), 'PPPP', { locale }); // форматирует дату в текущей локали
 *
 * @returns {Locale} Объект локали для использования в функциях date-fns (например, в format, parse, и др.)
 */

export function useDateFnsLocale() {
    return useMemo(() => {
        const code = (LOCALE || navigator.language || 'en-US').toLowerCase().replace('_', '-');
        return localeMap[code] || localeMap[code.split('-')[0]] || enUS;
    }, []);
}
